// src/authConfig.js
export const msalConfig = {
    auth: {
      clientId: process.env.REACT_APP_CLIENT_ID,
      authority: "https://login.microsoftonline.com/common",
      redirectUri: process.env.REACT_APP_REDIRECT_URI || window.location.origin,
      navigateToLoginRequestUrl: false
    },
    cache: { cacheLocation: "localStorage" }
  };
  
  export const loginRequest = {
    scopes: ["User.Read"]
  };
